import { useCallback, useEffect, useState } from "react";
import { AgentOSLayout } from "@/components/agent-os/AgentOSLayout";
import { apiFetch, formatDateTime, inputClass, Pill, Spinner } from "@/components/agent-os/shared";

export default function AgentOSAudit() {
    const [items, setItems] = useState(null);
    const [filters, setFilters] = useState({ agent_id: "", task_id: "", risk_level: "" });

    const load = useCallback(() => {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => value && params.set(key, value));
        apiFetch(`/audit?${params}`).then((r) => (r.ok ? r.json() : [])).then(setItems);
    }, [filters]);
    useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

    return (
        <AgentOSLayout title="Audit Trail" subtitle="Tamper-evident operational history for agent actions, tools, approvals, resources, risk and results.">
            <div className="mb-7 grid gap-3 lg:grid-cols-3" data-testid="audit-filters">
                <input data-testid="audit-agent-filter" value={filters.agent_id} onChange={(e) => setFilters({ ...filters, agent_id: e.target.value })} placeholder="Filter by agent…" className={inputClass} />
                <input data-testid="audit-task-filter" value={filters.task_id} onChange={(e) => setFilters({ ...filters, task_id: e.target.value })} placeholder="Filter by task…" className={inputClass} />
                <select data-testid="audit-risk-filter" value={filters.risk_level} onChange={(e) => setFilters({ ...filters, risk_level: e.target.value })} className={`${inputClass} cursor-pointer`}><option value="">All risk levels</option>{["low", "medium", "high", "critical"].map((risk) => <option key={risk} value={risk}>{risk}</option>)}</select>
            </div>
            {!items ? <Spinner /> : (
                <div className="border-t border-ink/10" data-testid="audit-list">
                    {items.map((item) => (
                        <article key={item.audit_id} data-testid={`audit-${item.audit_id}`} className="grid gap-4 border-b border-ink/10 py-4 lg:grid-cols-[auto_1fr_auto_auto] lg:items-center">
                            <Pill value={item.risk_level} risk />
                            <div className="min-w-0">
                                <p className="font-medium text-ink">{item.action.replace(/_/g, " ")} <span className="text-ink/40">→ {item.result}</span></p>
                                <p className="mt-1 truncate text-xs text-ink/50">{item.actor_email} · {item.agent_id || "no agent"} · {item.tool_id || "no tool"} · {item.resource || "no resource"}</p>
                            </div>
                            <Pill value={item.approval_status} />
                            <p className="text-xs text-ink/45">{formatDateTime(item.timestamp)}</p>
                        </article>
                    ))}
                    {items.length === 0 && <p className="py-14 text-center text-sm text-ink/50">No audit events match these filters.</p>}
                </div>
            )}
        </AgentOSLayout>
    );
}
